import React from 'react';
import Props from '../../types/props';
import Chip from '../single_component/Chip';
import CircleIcon from '@mui/icons-material/Circle';

export default function Priority({ children, ...props }: Props) {
  return (
    <Chip
      style={{
        color: 'white',
        fontSize: 10,
        height: 18,
        gap: 1,
        padding: 1,
        display: 'inline-flex',
        alignItems: 'center',
        background:
          props.label == 'LOW'
            ? '#D4BF00'
            : props.label == 'MEDIUM'
            ? '#D36829'
            : props.label == 'HIGH'
            ? '#B42318'
            : 'info',
      }}
      label={props.label}
      extra={{
        variant: 'filled',
        icons: <CircleIcon style={{ fontSize: 6, color: '#FFF' }} />,
      }}>
      {children}
    </Chip>
  );
}
